module.exports = __webpack_public_path__ + "static/media/externalBarn_10.35570a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_10.png
// module id = 1298
// module chunks = 3